// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1AEn5","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2xdj0","obliqueLine":"membershipbadge_obliqueLine__2XKbI"};